// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ellipsis {\n  overflow: hidden;    \n  text-overflow:ellipsis;    \n  white-space: nowrap\n}\n.flx {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n/* 使用系统字体和备选字体族 */\nbody {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Segoe UI\", Helvetica, Arial, \"PingFang SC\", \"Microsoft YaHei\", \"WenQuanYi Micro Hei\", sans-serif;\n}\n", ""]);
// Exports
module.exports = exports;
